import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const ChatAnalyticsTick: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M 15.980469 6.9902344 A 1.0001 1.0001 0 0 0 15.292969 7.2929688 L 11.455078 11.130859 A 1.0001 1.0001 0 1 0 12.869141 12.544922 L 16.707031 8.7070312 A 1.0001 1.0001 0 0 0 15.980469 6.9902344 z M 21.980469 6.9902344 A 1.0001 1.0001 0 0 0 21.292969 7.2929688 L 12 16.585938 L 8.7070312 13.292969 A 1.0001 1.0001 0 1 0 7.2929688 14.707031 L 11.292969 18.707031 A 1.0001 1.0001 0 0 0 12.707031 18.707031 L 22.707031 8.7070312 A 1.0001 1.0001 0 0 0 21.980469 6.9902344 z M 1.9902344 12.990234 A 1.0001 1.0001 0 0 0 1.2929688 14.707031 L 4.5449219 17.960938 A 1.0012744 1.0012744 0 1 0 5.9609375 16.544922 L 2.7070312 13.292969 A 1.0001 1.0001 0 0 0 1.9902344 12.990234 z"
        fill={props.fill}
      />
    </SvgIcon>
  );
};

export default ChatAnalyticsTick;
